import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigurationService } from '@interacta-shared/data-access-configuration';
import { map, Observable } from 'rxjs';
import { toNotificationsStream } from '../models/notification/notification.deserialize';
import {
    NotificationEvent,
    NotificationsStream,
} from '../models/notification/notification.model';
import { NOTIFICATION_CONFIG } from '../providers/notification.providers';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private readonly http = inject(HttpClient);
    private readonly config = inject(NOTIFICATION_CONFIG);
    private readonly configService = inject(ConfigurationService);

    fetchNotificationsStream(
        syncToken: string | null,
        pageToken: string | null,
        onlyUnread: boolean,
        pageSize: number,
    ): Observable<NotificationsStream> {
        let params: { [param: string]: string | number | boolean } = {
            pageSize,
        };

        if (pageToken != null) {
            params = {
                ...params,
                pageToken,
            };
        }

        if (syncToken != null) {
            params = {
                ...params,
                syncToken,
            };
        }

        if (onlyUnread) {
            params = {
                ...params,
                onlyUnread,
            };
        }

        return this.http
            .get(this.config.endpoints.stream, { params })
            .pipe(
                map((record) =>
                    toNotificationsStream(
                        record,
                        this.configService,
                        this.config.deserializeFn,
                    ),
                ),
            );
    }

    getUnreadNotificationsCount(): Observable<number> {
        return this.http
            .get<{
                count: number;
                overscale: boolean;
            }>(this.config.endpoints.unreadCount)
            .pipe(map((res) => res.count));
    }

    markNotificationAsRead(
        notificationId: NotificationEvent['id'],
    ): Observable<void> {
        return this.http.post<void>(this.config.endpoints.markAsRead, {
            notificationIds: [notificationId],
        });
    }

    markAllNotificationsAsRead(
        lastReadNotificationId: NotificationEvent['id'],
    ): Observable<void> {
        return this.http.post<void>(this.config.endpoints.markAllAsRead, {
            lastReadNotificationId,
        });
    }
}
